import { Tag } from '@cian/components';
import * as React from 'react';

import { IWordsIncludeTag } from '../../../state/tags/definitions/words_include';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IWordsIncludeTagItemProps {
  tag: IWordsIncludeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const WordsIncludeTagItem = ({ tag, onDeleteClick, withNewTag }: IWordsIncludeTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Содержит "{tag.value}"
    </TagComponent>
  );
};
